(function () {
  if (window.JuzooriBundleLanding) {
    return;
  }

  const BUNDLE_SIZE = 3;

  function formatMoney(cents, host) {
    const value = Number(cents);
    const baseUnits = Number(host && host.getAttribute('data-money-units')) || 0;
    const template = (host && host.getAttribute('data-money-formatted')) || '';
    if (Number.isNaN(value) || !baseUnits || template === '') {
      return '';
    }

    const numberPattern = /[\d٠-٩]+(?:[.,٫][\d٠-٩]+)*/;
    const match = template.match(numberPattern);
    if (!match) {
      return template;
    }

    const raw = match[0];
    const western = raw.replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
    const commaDecimal = /\d+,\d{1,3}$/.test(western) && western.indexOf('.') === -1;
    const parseable = commaDecimal ? western.replace(',', '.') : western.replace(/,/g, '');
    const baseMajor = Number.parseFloat(parseable.replace('٫', '.'));
    if (!baseMajor) {
      return template;
    }

    const major = (value / baseUnits) * baseMajor;
    const decimalPart = raw.split(/[.,٫]/)[1];
    const digits = decimalPart ? decimalPart.length : 0;
    let printed = digits > 0 ? major.toFixed(digits) : String(Math.round(major));
    if (commaDecimal) {
      printed = printed.replace('.', ',');
    } else if (raw.indexOf('٫') !== -1) {
      printed = printed.replace('.', '٫');
    }

    return template.replace(raw, printed);
  }

  async function addBundleToCart(variantIds) {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    const quantities = new Map();
    variantIds.forEach((id) => {
      const key = Number(id);
      quantities.set(key, (quantities.get(key) || 0) + 1);
    });

    const firstId = variantIds[0];
    const payload = {
      items: Array.from(quantities.entries()).map(([id, quantity]) => ({ id, quantity })),
      sections: sectionsToBundle.join(','),
      sections_url: Shopify.routes.root + 'variants/' + firstId
    };

    const response = await fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    const responseJson = await response.json();
    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || 'cart-error');
    }

    if (window.themeVariables && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
      window.location.href = Shopify.routes.root + 'cart';
      return;
    }

    const cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
    cartContent.sections = responseJson.sections;
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      })
    );
  }

  class JuzooriBundleLanding extends HTMLElement {
    constructor() {
      super();
      this.onCatalogClick = this.onCatalogClick.bind(this);
      this.onSlotClick = this.onSlotClick.bind(this);
      this.onAddClick = this.onAddClick.bind(this);
    }

    connectedCallback() {
      this.picks = [null, null, null];
      this.activeSlot = 0;
      this.brandFilter = 'all';
      this.catalog = this.querySelector('.bundle-landing__catalog');
      this.slotsRoot = this.querySelector('[data-slots]');
      this.saleEl = this.querySelector('[data-sale]');
      this.compareEl = this.querySelector('[data-compare]');
      this.hintEl = this.querySelector('[data-hint]');
      this.addBtn = this.querySelector('[data-add-bundle]');
      this.errorEl = this.querySelector('[data-error]');
      this.bundleButtonLabel = this.getAttribute('data-button-bundle') || '';
      this.partialButtonTemplate = this.getAttribute('data-button-partial') || this.bundleButtonLabel;
      this.errorText = this.getAttribute('data-error') || '';

      this.catalog?.addEventListener('click', this.onCatalogClick);
      this.slotsRoot?.addEventListener('click', this.onSlotClick);
      this.addBtn?.addEventListener('click', this.onAddClick);

      this.setBrandFilter('all');
      this.renderAllSlots();
      this.updatePrices();
    }

    disconnectedCallback() {
      this.catalog?.removeEventListener('click', this.onCatalogClick);
      this.slotsRoot?.removeEventListener('click', this.onSlotClick);
      this.addBtn?.removeEventListener('click', this.onAddClick);
    }

    onCatalogClick(event) {
      const filter = event.target.closest('[data-brand-filter]');
      if (filter) {
        event.preventDefault();
        this.setBrandFilter(filter.getAttribute('data-brand-filter') || 'all');
        return;
      }

      const color = event.target.closest('.juzoori-bogo-picker__color');
      if (color) {
        event.preventDefault();
        this.selectColor(color);
        return;
      }

      const size = event.target.closest('.juzoori-bogo-picker__size');
      if (size && !size.disabled) {
        event.preventDefault();
        this.selectSize(size);
      }
    }

    onSlotClick(event) {
      const remove = event.target.closest('[data-remove-slot]');
      if (remove) {
        event.preventDefault();
        event.stopPropagation();
        const slotEl = remove.closest('[data-slot]');
        const slotIndex = Number(slotEl && slotEl.getAttribute('data-slot'));
        if (!Number.isNaN(slotIndex)) {
          this.picks[slotIndex] = null;
          this.renderSlot(slotIndex);
          this.syncActiveSlot();
          this.updatePrices();
        }
        return;
      }

      const trigger = event.target.closest('.juzoori-bogo-card__trigger');
      const slotEl = event.target.closest('[data-slot]');
      if (trigger && slotEl && !slotEl.classList.contains('is-filled')) {
        this.activeSlot = Number(slotEl.getAttribute('data-slot')) || 0;
        this.renderActiveSlot();
      }
    }

    getItemVariants(item) {
      if (!item) {
        return [];
      }
      if (item._juzooriVariants) {
        return item._juzooriVariants;
      }
      const script = item.querySelector('.juzoori-bogo-picker__variants');
      if (!script) {
        item._juzooriVariants = [];
        return item._juzooriVariants;
      }
      try {
        item._juzooriVariants = JSON.parse(script.textContent || '[]');
      } catch (error) {
        item._juzooriVariants = [];
      }
      return item._juzooriVariants;
    }

    selectColor(button) {
      const item = button.closest('.juzoori-bogo-picker__item');
      if (!item) {
        return;
      }

      const styleValue = button.getAttribute('data-style-value') || '';
      item.setAttribute('data-selected-style', styleValue);
      item.querySelectorAll('.juzoori-bogo-picker__color').forEach((chip) => {
        const selected = chip === button;
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const previewImage = button.getAttribute('data-image');
      const media = item.querySelector('.juzoori-bogo-picker__image');
      if (media && previewImage) {
        media.src = previewImage;
        media.removeAttribute('srcset');
      }

      this.syncItemSizes(item);
    }

    syncItemSizes(item) {
      const variants = this.getItemVariants(item);
      const selectedStyle = item.getAttribute('data-selected-style') || '';
      const sizeButtons = item.querySelectorAll('.juzoori-bogo-picker__size[data-size-value]');

      sizeButtons.forEach((button) => {
        const sizeValue = button.getAttribute('data-size-value') || '';
        const match = variants.find((variant) => {
          const sizeOk = !sizeValue || variant.size === sizeValue;
          const styleOk = !selectedStyle || !variant.style || variant.style === selectedStyle;
          return sizeOk && styleOk;
        });

        if (match) {
          button.disabled = false;
          button.classList.remove('is-unavailable');
          button.setAttribute('data-variant-id', String(match.id));
          button.setAttribute('data-price', String(match.price || 0));
          if (match.image) {
            button.setAttribute('data-image', match.image);
          }
        } else {
          button.disabled = true;
          button.classList.add('is-unavailable');
          button.removeAttribute('data-variant-id');
        }
      });

      const priceEl = item.querySelector('[data-picker-price]');
      const firstAvailable = item.querySelector('.juzoori-bogo-picker__size[data-variant-id]:not([disabled])');
      if (priceEl && firstAvailable) {
        const cents = Number(firstAvailable.getAttribute('data-price')) || 0;
        const formatted = formatMoney(cents, this);
        if (formatted) {
          priceEl.textContent = formatted;
        }
      }
    }

    selectSize(button) {
      const item = button.closest('.juzoori-bogo-picker__item');
      if (!item || !button.getAttribute('data-variant-id')) {
        return;
      }

      let slotIndex = this.activeSlot;
      if (this.picks[slotIndex] != null) {
        slotIndex = this.picks.findIndex((pick) => !pick);
        if (slotIndex === -1) {
          return;
        }
      }

      const pick = {
        productId: item.getAttribute('data-product-id'),
        variantId: button.getAttribute('data-variant-id'),
        price: Number(button.getAttribute('data-price')) || 0,
        image: button.getAttribute('data-image') || item.getAttribute('data-image') || '',
        title: item.getAttribute('data-title') || ''
      };

      this.picks[slotIndex] = pick;
      this.renderSlot(slotIndex);
      this.syncActiveSlot();
      this.updatePrices();

      if (window.matchMedia('(max-width: 699px)').matches) {
        this.slotsRoot?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    setBrandFilter(brand) {
      this.brandFilter = brand || 'all';
      this.querySelectorAll('[data-brand-filter]').forEach((button) => {
        const selected = (button.getAttribute('data-brand-filter') || 'all') === this.brandFilter;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      this.querySelectorAll('.juzoori-bogo-picker__item').forEach((item) => {
        const itemBrand = item.getAttribute('data-brand') || '';
        item.hidden = this.brandFilter !== 'all' && itemBrand !== this.brandFilter;
      });
    }

    syncActiveSlot() {
      const next = this.picks.findIndex((pick) => !pick);
      this.activeSlot = next === -1 ? BUNDLE_SIZE - 1 : next;
      this.renderActiveSlot();
    }

    renderActiveSlot() {
      if (!this.slotsRoot) {
        return;
      }
      this.slotsRoot.querySelectorAll('[data-slot]').forEach((slotEl) => {
        const index = Number(slotEl.getAttribute('data-slot'));
        const isActive = index === this.activeSlot && !slotEl.classList.contains('is-filled');
        slotEl.classList.toggle('is-active', isActive);
      });
    }

    renderAllSlots() {
      for (let i = 0; i < BUNDLE_SIZE; i += 1) {
        this.renderSlot(i);
      }
      this.renderActiveSlot();
    }

    renderSlot(slotIndex) {
      const slotEl = this.slotsRoot?.querySelector('[data-slot="' + slotIndex + '"]');
      if (!slotEl) {
        return;
      }
      const pick = this.picks[slotIndex];
      const thumb = slotEl.querySelector('.juzoori-bogo-card__thumb');
      const plus = slotEl.querySelector('.juzoori-bogo-card__plus');
      const remove = slotEl.querySelector('[data-remove-slot]');

      if (!pick) {
        slotEl.classList.remove('is-filled');
        if (thumb) {
          thumb.hidden = true;
          thumb.removeAttribute('src');
          thumb.alt = '';
        }
        if (plus) {
          plus.hidden = false;
        }
        if (remove) {
          remove.hidden = true;
        }
        return;
      }

      slotEl.classList.add('is-filled');
      if (thumb) {
        if (pick.image) {
          thumb.src = pick.image;
          thumb.srcset = pick.image + ' 720w';
          thumb.sizes = '(min-width: 700px) 110px, 18vw';
          thumb.hidden = false;
        } else {
          thumb.hidden = true;
        }
        thumb.alt = pick.title;
      }
      if (plus) {
        plus.hidden = true;
      }
      if (remove) {
        remove.hidden = false;
      }
    }

    updateHint(key) {
      if (!this.hintEl) {
        return;
      }
      const text = this.getAttribute('data-hint-' + key);
      if (text) {
        this.hintEl.textContent = text;
      }
    }

    partialButtonLabel(count) {
      return this.partialButtonTemplate.replace('[count]', String(count));
    }

    updatePrices() {
      const filled = this.picks.filter(Boolean);
      const count = filled.length;
      const prices = filled.map((pick) => pick.price);
      let sale = prices.reduce((sum, price) => sum + price, 0);
      let compare = sale;
      let hintKey = 'pick';

      if (count === 0) {
        sale = 0;
        compare = 0;
        hintKey = 'pick';
      } else if (count === 1) {
        hintKey = 'two-more';
      } else if (count === 2) {
        hintKey = 'one-more';
      } else {
        compare = prices.reduce((sum, price) => sum + price, 0);
        sale = compare - Math.min.apply(null, prices);
        hintKey = 'ready';
      }

      this.updateHint(hintKey);

      if (this.saleEl) {
        const formatted = count === 0 ? formatMoney(0, this) : formatMoney(sale, this);
        if (formatted) {
          this.saleEl.textContent = formatted;
        }
      }

      if (this.compareEl) {
        const compareFormatted = formatMoney(compare, this);
        if (compareFormatted) {
          this.compareEl.textContent = compareFormatted;
        }
        this.compareEl.hidden = count !== BUNDLE_SIZE || sale >= compare;
      }

      if (this.addBtn) {
        this.addBtn.disabled = count !== BUNDLE_SIZE;
        this.addBtn.textContent = count === BUNDLE_SIZE
          ? this.bundleButtonLabel
          : (count > 0 ? this.partialButtonLabel(count) : this.bundleButtonLabel);
      }

      if (this.errorEl) {
        this.errorEl.hidden = true;
      }
    }

    async onAddClick(event) {
      event.preventDefault();
      const picks = this.picks.filter(Boolean);
      if (picks.length !== BUNDLE_SIZE || this.addBtn?.getAttribute('aria-busy') === 'true') {
        return;
      }

      this.addBtn.setAttribute('aria-busy', 'true');
      try {
        await addBundleToCart(picks.map((pick) => pick.variantId));
        this.picks = [null, null, null];
        this.renderAllSlots();
        this.updatePrices();
      } catch (error) {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.textContent = this.errorText;
        }
      } finally {
        this.addBtn.removeAttribute('aria-busy');
      }
    }
  }

  window.JuzooriBundleLanding = JuzooriBundleLanding;

  if (!window.customElements.get('juzoori-bundle-landing')) {
    window.customElements.define('juzoori-bundle-landing', JuzooriBundleLanding);
  }
})();
